export type AbaServidor = 'inicio' | 'comprovante' | 'ajuste' | 'ferias' | 'oficio' | 'senha';

export interface ItemNavegacaoServidor {
  id: AbaServidor;
  rotulo: string;
}

export interface AtalhoDashboardServidor {
  id: AbaServidor;
  rotulo: string;
  icone: string;
}

export function itensNavegacaoServidor(): ItemNavegacaoServidor[] {
  return [
    { id: 'inicio', rotulo: 'Inicio' },
    { id: 'senha', rotulo: 'Senha' }
  ];
}

export function atalhosDashboardServidor(podeOficios = false): AtalhoDashboardServidor[] {
  const atalhos: AtalhoDashboardServidor[] = [
    { id: 'comprovante', rotulo: 'Comprovante de Marcações', icone: 'bi-clock-history' },
    { id: 'ajuste', rotulo: 'Solicitar inclusão de marcação', icone: 'bi-plus-circle' },
    { id: 'ferias', rotulo: 'Solicitar Férias', icone: 'bi-calendar2-week' }
  ];
  if (podeOficios) {
    atalhos.push({ id: 'oficio', rotulo: 'Solicitar Número de Documento', icone: 'bi-file-earmark-text' });
  }
  return atalhos;
}

export function abaServidorPorUrl(url: string): AbaServidor {
  const partes = (url || '')
    .split('?')[0]
    .split('#')[0]
    .replace(/^\/+/, '')
    .split('/')
    .filter(Boolean);
  const segunda = partes[1] || '';
  if (segunda === 'comprovante' || segunda === 'batidas') {
    return 'comprovante';
  }
  if (segunda === 'ajuste' || segunda === 'ferias' || segunda === 'oficio' || segunda === 'senha') {
    return segunda;
  }
  return 'inicio';
}

export function rotaDaAbaServidor(aba: AbaServidor) {
  return aba === 'inicio' ? '/servidor' : `/servidor/${aba}`;
}
